module.exports = __webpack_public_path__ + "img/search_bg_crop.2b6a7274.png";